import { OurWorksBannerProps } from "@script/gutenberg/components/organisms/our-works/our-works-listing";

interface acf {
	acf: {
		background_image?: string;
		banner_image?: string;
		body?: string;
		region?: string;
		location_icon?: string;
		cta_label?: string;
		cta_link?: string;
		cta_target?: string;
		name: string;
		size: string;
		tech_stack?: string[];
		tags?: string;
		theme: string;
		title: string;
		type: string;
	};
	categories?: string;
}

interface ProjectProps extends acf, OurWorksBannerProps {}

export function renderProject(props: ProjectProps, index: number) {
	const acf = props.acf || {};

	const name = acf.name || "";
	const type = acf.type || "";
	const title = acf.title || props.title || "";
	const body = acf.body || "";
	const region = acf.region || "";
	const techStack = acf.tech_stack || [];
	const locationIcon = acf.location_icon || [];


	// const tags = acf.tags ? acf.tags.split(",").map((t) => t.trim()) : [];
	// TODO: Pre-deployment essential
	// const tags = props.categories || [];
	const tags = [];

	const cta = {
		// TODO: Pre-deployment essential
		// href: acf.cta_link || "",
		href: "",
		label: acf.cta_label || "",
		target: acf.cta_target && acf.cta_target === "new" ? "_blank" : "_self",
	};

	const theme = acf.theme || "light";
	const background = acf.background_image;
	const banner = acf.banner_image;
	let size = acf.size || "auto";

	const sizes = ["large", "small", "small"];
	if (size === "auto") size = sizes[index % sizes.length];

	const themeClass = theme === "dark" ? "dark" : "";
	const sizeClass =
		size === "small"
			? "md:col-span-1 md:min-h-[35rem] lg:min-h-[41.875rem]"
			: "md:justify-center md:items-end md:min-h-[25rem] xl:min-h-[28.5rem]";

	const bannerImgClass =
		size === "small" ? "md:h-[54%]" : "md:w-[36%] md:h-full";

	const textLimit =
		tags.length > 3
			? `<div class="flex items-center font-sans text-[0.625rem] uppercase font-bold">+ ${
					tags.length - 3
			  } more</div>`
			: "";

	return `
		<div class="col-span-full ${themeClass} flex flex-col relative w-full bg-slate-300 rounded-lg overflow-hidden ${sizeClass}">
			${
				background
					? `
				<div class="js-lazy-bg absolute top-0 left-0 w-full h-full bg-cover bg-center" data-bg="${background}"></div>
			`
					: ""
			}
			<div class="z-10 relative flex flex-col gap-6 w-full ${
				size !== "small" ? "md:w-[60%]" : ""
			} px-4 pt-8 pb-6 lg:p-10 text-p3 text-neutral-60 dark:text-neutral-dark-60">
				${
					name || type
						? `
					<div class="text-p3 flex">
						<span>${name}</span>
						<span class="px-2">•</span>
						<span>${type}</span>
						${
							region &&
							`<div ${type ? `class="flex pl-2"` : `class="flex pl-0"`} >
							<img class="js-lazy block max-h-[3rem] object-contain" src="${locationIcon ? locationIcon.url : "/wp-content/themes/section/assets/images/tech-stack/Office.svg"}" />
								<span class="text-p3">${region}</span>
							</div>`
						}
					</div>
				`
						: ""
				}
				<div class="flex flex-col gap-4">
					${title ? `<h4 class="font-anth text-h4-mobile md:text-h4">${title}</h4>` : ""}
					${body ? `<p>${body}</p>` : ""}
				</div>
				${
					tags.length > 0
						? `
					<div class="flex flex-wrap gap-2">
						${tags
							.slice(0, 3)
							.map(
								(t) => `
							<div class="px-2 py-[0.3125rem] bg-neutral-10 bg-opacity-80 text-[0.625rem] uppercase font-bold text-neutral-50 rounded cursor-default">${t}</div>
						`,
							)
							.join("")}
						${textLimit}
					</div>
				`
						: ""
				}
                ${
									techStack.length > 0
										? `
                <div class="flex flex-col gap-2">
                    <div class="text-label-pill uppercase">tech stack</div>
                    <div class="flex flex-wrap gap-x-4">
                        ${techStack
													.map(
														(item) =>
															`<img class="js-lazy block max-h-[3rem] object-contain" data-src="${item.url}" />`,
													)
													.join("")}
                    </div>
                </div>
                `
										: ""
								}
			</div>
			${
				banner
					? `
				<div class="flex items-end justify-start relative md:absolute bottom-0 left-0 w-full ${bannerImgClass}">
					<img class="js-lazy w-full object-contain" data-src="${banner}" />
				</div>
			`
					: ""
			}
			${
				cta && cta.href
					? `
				<a class="z-10 absolute block top-0 left-0 w-full h-full" href="${
					cta.href
				}" target="${cta.target}">
					<span class="opacity-0 pointer-events-none">${cta.label || "View"}</span>
				</a>
			`
					: ""
			}
		</div>
	`;
}
